import { useState, useEffect } from "react";
import ErrorMessage from "components/ErrorMessage";

const INITIAL_VALUES = {
    nit: "",
    kunnr: "",
    razonSocial: "",
    direccion: "",
    typeSale: {
        tangible: false,
        intangible: false,
        recargaPasatiempo: false,
        recargaEnLineaPQ: false
    },
    regions: {
        CO03: false,
        CO04: false,
        CO05: false
    }

};


function OrganizationForm({
    createOrganization,
    updateOrganization,
    selectedOrganizacion,
    setSelectedOrganizacion,
    setIsSearched
}) {

    const [form, setForm] = useState(INITIAL_VALUES);
    const [error, setError] = useState("");

    const isEditing = selectedOrganizacion?._id;

    useEffect(() => {

        if (!selectedOrganizacion) return;

        const selectedRegions = selectedOrganizacion.regions || [];

        const regionObject = {
            CO03: selectedRegions.includes("CO03"),
            CO04: selectedRegions.includes("CO04"),
            CO05: selectedRegions.includes("CO05")
        };


        setForm({
            ...selectedOrganizacion,
            regions: regionObject
        });

    }, [selectedOrganizacion]);



    // ------------------------

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const handleCheck = (e) => {
        const { name, checked } = e.target;

        setForm({
            ...form,
            typeSale: {
                ...form.typeSale,
                [name]: checked
            }
        });
    };

    // ------------------------

    const validate = () => {

        if (!form.nit || !form.kunnr || !form.razonSocial) {
            return "NIT, KUNNR y Razón Social son obligatorios.";
        }

        if (!form.typeSale.tangible && !form.typeSale.intangible) {
            return "Debes seleccionar al menos un tipo de venta.";
        }

        if (
            form.typeSale.intangible &&
            !form.typeSale.recargaPasatiempo &&
            !form.typeSale.recargaEnLineaPQ
        ) {
            return "Selecciona al menos una recarga para venta intangible.";
        }

        return "";
    };

    // ------------------------

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationError = validate();

        if (validationError) {
            setError(validationError);
            return;
        }

        setError("");

        const normalizedForm = {
            ...form,
            regions: Object
                .keys(form.regions)
                .filter(code => form.regions[code])
        };

        try {

            let status;

            if (isEditing) {

                status = await updateOrganization({
                    id: selectedOrganizacion._id,
                    organization: normalizedForm
                });

            } else {

                status = await createOrganization(normalizedForm);
            }

            // Solo limpiar si TODO salió bien
            if (status) {
                setForm(INITIAL_VALUES);
                setSelectedOrganizacion(null);

                setIsSearched({
                    search: "",
                    option: "",
                    state: false
                });
            }

        } catch (error) {

            console.error(error);
            setError("Ocurrió un error al guardar la organización");

        }
    };


    const handleReset = () => {
        setForm(INITIAL_VALUES);
        setSelectedOrganizacion(null);
        setError("");
    };

    const REGIONS = [
        { code: "CO03", name: "Oriente" },
        { code: "CO04", name: "Occidente" },
        { code: "CO05", name: "Costa" }
    ];

    const handleRegionCheck = (e) => {
        const { name, checked } = e.target;

        setForm({
            ...form,
            regions: {
                ...form.regions,
                [name]: checked
            }
        });
    };



    // ------------------------

    return (
        <div className="mt-4">

            <h6>{isEditing ? "Editar" : "Agregar"} Organización</h6>

            {error && <ErrorMessage message={error} />}

            <div className="rounded-3 p-4 border">

                <form onSubmit={handleSubmit}>

                    {/* NIT + KUNNR */}
                    <div className="row">

                        <div className="col-md-3 mb-3">
                            <label>NIT *</label>
                            <input
                                className="form-control"
                                name="nit"
                                value={form.nit}
                                onChange={handleChange}
                                disabled={isEditing}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>KUNNR *</label>
                            <input
                                className="form-control"
                                name="kunnr"
                                value={form.kunnr}
                                onChange={handleChange}
                                disabled={isEditing}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Razón Social *</label>
                            <input
                                className="form-control"
                                name="razonSocial"
                                value={form.razonSocial}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Dirección *</label>
                            <input
                                className="form-control"
                                name="direccion"
                                value={form.direccion}
                                onChange={handleChange}
                            />
                        </div>

                    </div>

                    {/* TYPE SALE */}

                    <div className="mt-3">
                        <label className="fw-bold">
                            Tipo de Venta *
                        </label>

                        <div className="form-check">
                            <input
                                type="checkbox"
                                name="tangible"
                                checked={form.typeSale.tangible}
                                onChange={handleCheck}
                                className="form-check-input"
                            />
                            <label className="form-check-label">
                                Tangible
                            </label>
                        </div>

                        <div className="form-check">
                            <input
                                type="checkbox"
                                name="intangible"
                                checked={form.typeSale.intangible}
                                onChange={handleCheck}
                                className="form-check-input"
                            />
                            <label className="form-check-label">
                                Intangible
                            </label>
                        </div>
                    </div>

                    {/* RECARGAS SOLO SI INTANGIBLE */}

                    {form.typeSale.intangible && (
                        <div className="mt-3 ms-3 border-start ps-3">

                            <label className="fw-bold">
                                Opciones de Recarga *
                            </label>

                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    name="recargaPasatiempo"
                                    checked={form.typeSale.recargaPasatiempo}
                                    onChange={handleCheck}
                                    className="form-check-input"
                                />
                                <label className="form-check-label">
                                    Recarga Pasatiempo
                                </label>
                            </div>

                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    name="recargaEnLineaPQ"
                                    checked={form.typeSale.recargaEnLineaPQ}
                                    onChange={handleCheck}
                                    className="form-check-input"
                                />
                                <label className="form-check-label">
                                    Recarga En Línea - PQ
                                </label>
                            </div>

                        </div>
                    )}

                    {/* REGIONES */}
                    <label className="fw-bold">
                        Selección de Región (Opcional)
                    </label>
                    {REGIONS.map(region => (
                        <div className="form-check" key={region.code}>
                            <input
                                type="checkbox"
                                name={region.code}
                                checked={form.regions?.[region.code] || false}
                                onChange={handleRegionCheck}
                                className="form-check-input"
                            />
                            <label className="form-check-label">
                                {region.name} ({region.code})
                            </label>
                        </div>
                    ))}



                    {/* BUTTONS */}

                    <div className="mt-4 d-flex gap-2">

                        <button className="btn btn-success w-50">
                            {isEditing ? "Actualizar" : "Guardar"}
                        </button>

                        <button
                            type="button"
                            className="btn btn-secondary w-50"
                            onClick={handleReset}
                        >
                            Limpiar
                        </button>

                    </div>

                </form>

            </div>
        </div>
    );
}

export default OrganizationForm;
